<template>
  <WdsStack gap-sm direction-column>
    <WdsSelect
      v-model="selectedCompanyAccounts"
      multi-select
      searchable
      :label="meta.filter.quickFilter ? '' : $t('Companies')"
      :list="accounts"
      :placeholder="$t('Select companies to filter by')"
      max-labels-visible="5"
      can-deselect
      labels-primary
    />
    <WdsCheckbox :checked="allChecked" @update:checked="toggleAccounts">
      {{ $t('Select all') }}
    </WdsCheckbox>
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsCheckbox, WdsSelect, WdsStack } from '@worksome/wds-components'
import { computed, ModelRef } from 'vue'
import { AccountStoreType } from '@/components/GraphqlDataTable/filters/accounts/accounts-store'
import { $t } from '@/composables/translation'
import { useCompanyAccounts } from '@/components/GraphqlDataTable/composables'
import { FilterMetaDataProp } from '@/components/GraphqlDataTable/filters/types'

const selectedCompanyAccounts: ModelRef<AccountStoreType[]> = defineModel({
  default: () => [],
})

defineProps<{ meta: FilterMetaDataProp }>()
const { accounts } = useCompanyAccounts()

const allChecked = computed(
  () =>
    selectedCompanyAccounts.value?.length === accounts.value.length &&
    !!selectedCompanyAccounts.value?.length,
)

const toggleAccounts = (event: boolean) => {
  // If 'event' is true, select all accounts; otherwise, deselect all
  selectedCompanyAccounts.value = event ? accounts.value : []
}
</script>
